// Schedule H column definitions — generic/neutral fallback labels.
// Onboarding MUST supply client-specific labels via /schedule-h/schema.
// These exist only as structural fallback so column keys/mapTo are defined.
// No "Division", "BU", "Fringe 100", or "Fringe 101" bias.

export const SCHEDULE_H_COLUMNS = Object.freeze([
  { label: 'Start year', key: 'start_year' },
  { label: 'Internal Contract Number', key: 'internal_contract_number', mapTo: 'internal_contract_number' },
  { label: 'Level 1 Project Number', key: 'level_1_project_number', mapTo: 'level_1_project_number' },
  { label: 'Prime Contract Number', key: 'prime_contract_number' },
  { label: 'Sub Contract Number', key: 'sub_contract_number' },
  { label: 'Contract Type', key: 'contract_type', mapTo: 'contract_type' },
  { label: 'Prime or Sub', key: 'prime_or_sub' },
  { label: 'DoD or Non DoD', key: 'dod_or_non_dod' },

  { label: 'DL 02 Company', key: 'dl_div02_company', mapTo: 'dl_div02_company' },
  { label: 'DL 02 Company Unbillable', key: 'dl_div02_company_unbillable', mapTo: 'dl_div02_company_unbillable' },
  { label: 'DL 02 Client', key: 'dl_div02_client', mapTo: 'dl_div02_client' },
  { label: 'DL 02 Client Unbillable', key: 'dl_div02_client_unbillable', mapTo: 'dl_div02_client_unbillable' },
  { label: 'DL 04 Company', key: 'dl_div04_company', mapTo: 'dl_div04_company' },
  { label: 'DL 04 Company Unbillable', key: 'dl_div04_company_unbillable', mapTo: 'dl_div04_company_unbillable' },
  { label: 'DL 04 Client', key: 'dl_div04_client', mapTo: 'dl_div04_client' },
  { label: 'DL 04 Client Unbillable', key: 'dl_div04_client_unbillable', mapTo: 'dl_div04_client_unbillable' },
  { label: 'DL 06 Company', key: 'dl_div06_company', mapTo: 'dl_div06_company' },
  { label: 'DL 06 Company Unbillable', key: 'dl_div06_company_unbillable', mapTo: 'dl_div06_company_unbillable' },
  { label: 'DL 06 Client', key: 'dl_div06_client', mapTo: 'dl_div06_client' },
  { label: 'DL 06 Client Unbillable', key: 'dl_div06_client_unbillable', mapTo: 'dl_div06_client_unbillable' },
  { label: 'DL 06 Client Unbillable', key: 'dl_div06_client_unbillable_dup' },
  { label: 'DL 08 Company', key: 'dl_div08_company', mapTo: 'dl_div08_company' },
  { label: 'DL 08 Company Unbillable', key: 'dl_div08_company_unbillable', mapTo: 'dl_div08_company_unbillable' },
  { label: 'DL 10 Company', key: 'dl_div10_company', mapTo: 'dl_div10_company' },
  { label: 'DL 10 Company Unbillable', key: 'dl_div10_company_unbillable', mapTo: 'dl_div10_company_unbillable' },
  { label: 'DL 10 Client', key: 'dl_div10_client', mapTo: 'dl_div10_client' },
  { label: 'DL 10 Client Unbillable', key: 'dl_div10_client_unbillable', mapTo: 'dl_div10_client_unbillable' },
  { label: 'DL 10 Client (Fringe Alt)', key: 'dl_div10_client_fringe101', mapTo: 'dl_div10_client_fringe101' },
  { label: 'DL 11', key: 'dl_div11', mapTo: 'dl_div11' },
  { label: 'DL 11 Unbillable', key: 'dl_div11_unbillable', mapTo: 'dl_div11_unbillable' },
  { label: 'DL No Pool', key: 'dl_no_division', mapTo: 'dl_no_division' },
  { label: 'DL No Pool Unbillable', key: 'dl_no_division_unbillable', mapTo: 'dl_no_division_unbillable' },
  { label: 'DL No Pool Client Unbillable', key: 'dl_no_division_client_unb' },
  { label: 'Total Direct Labor', key: 'total_direct_labor', mapTo: 'total_direct_labor' },
  { label: 'Other Unallowable', key: 'other_unallowable', mapTo: 'other_unallowable' },
  { label: 'ODCs Other', key: 'odcs_other', mapTo: 'odcs_other' },
  { label: 'Travel ODC', key: 'travel_odc', mapTo: 'travel_odc' },
  { label: 'Unbillable ODCs', key: 'unbillable_odcs', mapTo: 'unbillable_odcs' },
  { label: 'Unburdened ODCs (No G&A)', key: 'unburdened_odcs', mapTo: 'unburdened_odcs' },
  { label: 'Subcontractor & Consultants Labor', key: 'sub_cons_labor', mapTo: 'sub_cons_labor' },
  { label: 'Subcontractor & Consultants ODCs', key: 'sub_cons_odcs', mapTo: 'sub_cons_odcs' },
  { label: 'SUB ODCs, POs, Sub Labor as ODC, and Materials - Unbillable', key: 'sub_odcs_unbillable', mapTo: 'sub_odcs_unbillable' },
  { label: 'Materials', key: 'materials', mapTo: 'materials' },
  { label: 'Materials Unbillable', key: 'materials_unbillable', mapTo: 'materials_unbillable' },
  { label: 'CIO-CS-CAF (ODC non-burdened G&A)', key: 'cio_cs_caf', mapTo: 'cio_cs_caf' },
  { label: 'Total Direct Costs', key: 'total_direct_costs', mapTo: 'total_direct_costs' },
  { label: 'Total Non-Labor Costs', key: 'total_non_labor_costs', mapTo: 'total_non_labor_costs' },

  { label: 'Fringe 02 Company', key: 'fringe_div02_company', mapTo: 'fringe_div02_company' },
  { label: 'OH 02 Company', key: 'oh_div02_company', mapTo: 'oh_div02_company' },
  { label: 'Fringe 02 Client', key: 'fringe_div02_client', mapTo: 'fringe_div02_client' },
  { label: 'OH 02 Client', key: 'oh_div02_client', mapTo: 'oh_div02_client' },
  { label: 'Fringe 04 Company', key: 'fringe_div04_company', mapTo: 'fringe_div04_company' },
  { label: 'OH 04 Company', key: 'oh_div04_company', mapTo: 'oh_div04_company' },
  { label: 'Fringe 04 Client', key: 'fringe_div04_client', mapTo: 'fringe_div04_client' },
  { label: 'OH 04 Client', key: 'oh_div04_client', mapTo: 'oh_div04_client' },
  { label: 'Fringe 06 Company', key: 'fringe_div06_company', mapTo: 'fringe_div06_company' },
  { label: 'OH 06 Company', key: 'oh_div06_company', mapTo: 'oh_div06_company' },
  { label: 'Fringe 06 Client', key: 'fringe_div06_client', mapTo: 'fringe_div06_client' },
  { label: 'OH 06 Client', key: 'oh_div06_client', mapTo: 'oh_div06_client' },
  { label: 'Fringe 08 Company', key: 'fringe_div08_company', mapTo: 'fringe_div08_company' },
  { label: 'OH 08 Company', key: 'oh_div08_company', mapTo: 'oh_div08_company' },
  { label: 'Fringe 10 Company', key: 'fringe_div10_company', mapTo: 'fringe_div10_company' },
  { label: 'OH 10 Company', key: 'oh_div10_company', mapTo: 'oh_div10_company' },
  { label: 'Fringe 10 Client', key: 'fringe_div10_client', mapTo: 'fringe_div10_client' },
  { label: 'Fringe Alt 10 Client', key: 'fringe_101_div10_client', mapTo: 'fringe_101_div10_client' },
  { label: 'OH 10 Client', key: 'oh_div10_client', mapTo: 'oh_div10_client' },
  { label: 'Fringe 11 Company', key: 'fringe_div11', mapTo: 'fringe_div11' },
  { label: 'OH 11 Company', key: 'oh_div11', mapTo: 'oh_div11' },

  { label: 'Fringe on B&P', key: 'bp_fringe', mapTo: 'bp_fringe' },
  { label: 'Fringe on DL No Pool', key: 'fringe_no_division', mapTo: 'fringe_no_division' },
  // Phase 7c: wizard-native single-pool fringe / OH columns
  { label: 'Claimed Fringe', key: 'claimed_fringe', mapTo: 'claimed_fringe' },
  { label: 'Claimed OH', key: 'claimed_oh', mapTo: 'claimed_oh' },
  { label: 'Direct Costs & Overhead', key: 'direct_costs_overhead', mapTo: 'direct_costs_overhead' },
  { label: 'SM&H', key: 'smh', mapTo: 'smh' },
  { label: 'G&A Base Subtotal', key: 'ga_base_subtotal', mapTo: 'ga_base_subtotal' },
  { label: 'G&A', key: 'ga', mapTo: 'ga' },
  { label: 'Fringe Ceiling', key: 'fringe_ceiling' },
  { label: 'OH 02 Company Ceiling', key: 'oh2_company_ceiling' },
  { label: 'OH 04 Company Ceiling', key: 'oh4_company_ceiling' },
  { label: 'OH 10 Company Ceiling', key: 'oh10_company_ceiling' },
  { label: 'OH 10 Client Ceiling', key: 'oh10_client_ceiling' },
  { label: 'G&A Ceiling', key: 'ga_ceiling' },
  { label: 'SM&H Ceiling', key: 'smh_ceiling' },

  { label: 'G&A Applied to ODC (No Burden)', key: 'ga_applied_odc_no_burden' },
  { label: 'Total Costs', key: 'total_costs', mapTo: 'total_costs' }
]);

export default SCHEDULE_H_COLUMNS;
